import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { FieldDataChangedEvent } from "devextreme/ui/form";
import { ReportDesignItemSelectboxValue } from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-form-renderer-selectbox",
  templateUrl: "report-form-renderer-selectbox.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererSelectboxComponent implements OnInit, OnChanges {
  @Input()
  item!: ReportDesignItemSelectboxValue;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  formData = {
    value: "" as string | null
  };

  readonly editorOptions: {
    dataSource: string[];
    valueChangeEvent: "change";
  } = {
    dataSource: [],
    valueChangeEvent: "change"
  };

  ngOnInit(): void {
    this.updateFormData();
    this.updateOptionsDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["item"]) {
      this.updateFormData();
      this.updateOptionsDataSource();
    }
  }

  private updateFormData(): void {
    this.formData.value = this.item?.value ?? null;
  }

  private updateOptionsDataSource(): void {
    this.editorOptions.dataSource = this.parseOptions(
      this.item?.config?.options ?? ""
    );
  }

  private parseOptions(optionsStr: string): string[] {
    if (!optionsStr?.trim()) {
      return [];
    }

    return optionsStr
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  async renderPdfObject(): Promise<Record<string, unknown>> {
    return {
      type: "selectbox",
      config: {
        title: this.item.config?.title,
        value: this.formData.value
      }
    };
  }

  onFieldDataChanged({ value }: FieldDataChangedEvent): void {
    this.formData.value = value ?? null;
    this.item.value = value ?? "";

    this.value.emit(value ?? "");
  }
}
